<template>
  <!-- ======= How to recharge ======= -->
  <section id="how-to-recharge" class="team section-bg">
    <div class="container" data-aos="fade-up">
      <div class="section-title">
        <h2>How to recharge</h2>
      </div>
      <div class="row">
        <div class="col-lg-3 mt-2 mb-2 d-flex" >
          <div class="member align-items-start" data-aos="zoom-in" data-aos-delay="100">
            <div class="row">
              <div class="col-12 col-md-4">
                <div class="pic"><img src="" class="img-fluid" alt=""></div>
              </div>
              <div class="col-12 col-md-12">
                <div class="member-info">
                  <img src="assets/img/smartphone.png" alt="smartphone">
                  <h4 class="enter-phone">Enter Phone Number</h4>
                  <span>Enter the mobile phone number you wish to recharge and select your carrier.</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-3 mt-2 mb-2 d-flex">
          <div class="member align-items-start" data-aos="zoom-in" data-aos-delay="100">
            <div class="row">
              <div class="col-12 col-md-12">
                <div class="member-info">
                  <img src="assets/img/choice.png" alt="choice">
                  <h4 class="select-topup">Select Top-Up Amount</h4>
                  <span>Review all the available amounts online and choose a mobile recharge amount. Please verify the mobile number for Top-Up and check for any promotions and offers.</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-3 mt-2 mb-2 d-flex">
          <div class="member align-items-start" data-aos="zoom-in" data-aos-delay="100">
            <div class="row">
              <div class="col-12 col-md-4">
                <div class="pic"><img src="" class="img-fluid" alt=""></div>
              </div>
              <div class="col-12 col-md-12">
                <div class="member-info">
                  <img src="assets/img/paymentmethod.png" alt="payment">
                  <h4 class="complete-payment">Complete Payment</h4>
                  <span>Review your Top-Up order and complete payment using our secure payment process.</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-3 mt-2 mb-2 d-flex">
          <div class="member align-items-start" data-aos="zoom-in" data-aos-delay="100">
            <div class="row">
              <div class="col-12 col-md-4">
                <div class="pic"><img src="" class="img-fluid" alt=""></div>
              </div>
              <div class="col-12 col-md-12">
                <div class="member-info">
                  <img src="assets/img/success.png" alt="success">
                  <h4 class="successfully-recharged">Successfully Recharged</h4>
                  <span>Finally you will get the Top-Up amount you have requested for.</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section><!-- End how to recharge Section -->
</template>
<script>
export default {
  data() {
    return {
    }
  }
}
</script>
<style lang="scss" scoped>
.member-info {
  text-align: center;
}
.member-info img {
  width: 120px;
  margin: 20px 0;
}
.enter-phone {
  color: #8f2d56;
}
.select-topup {
  color: #8f2d56;
}
.complete-payment {
  color: #8f2d56;
}
.successfully-recharged {
  color: #8f2d56;
}
@media (max-width: 991px) {
  .member-info{
    margin-top: 10px;
    padding-left: 0 !important;
  }
}
</style>